// extracted by mini-css-extract-plugin
export var noProject = "Projects-module--noProject--m7r4Y";
export var previewImage = "Projects-module--previewImage--4jw0L";
export var projects = "Projects-module--projects--ILJ+L";